import { InputNumberLocalized } from '@components'

import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useManualPayment, usePaymentModal } from '../../../../../../../paymentReconciliationModal/contexts'
import { calculateConvertedAmount } from '../../../../../../../paymentReconciliationModal/utils'
import * as Styled from './styles'

interface PartialOrOverPaymentInputProps {
  convertedCurrencyId?: string
  subjectCurrencyId?: string | null
}
export const PartialOrOverPaymentInput = ({
  convertedCurrencyId,
  subjectCurrencyId,
}: PartialOrOverPaymentInputProps): ReactElement => {
  const { t } = useTranslation()

  const { exchangeRate } = usePaymentModal()
  const { crossCurrencyPaymentAmount, setCrossCurrencyPaymentAmount } = useManualPayment()
  const convertedAmount = calculateConvertedAmount(exchangeRate ?? 1, crossCurrencyPaymentAmount)

  return (
    <Flex flexDirection="row" alignItems="center" justifyContent="flex-end" gap={Spacing.S8}>
      <Flex flexDirection="row" alignItems="center" gap={Spacing.S8}>
        <Text variant="bodySM" colorVariant="secondary">
          {t('subject.payment_reconcile.cross_currency.estimated_conversion')}
        </Text>
        <Flex flexDirection="row" alignItems="center" justifyContent="center" gap={Spacing.S4}>
          <Text weight="bold" colorVariant="secondary">
            {convertedAmount}
          </Text>
          <Text colorVariant="secondary">{convertedCurrencyId}</Text>
        </Flex>
      </Flex>
      <Styled.PaymentInputWrapper>
        <InputNumberLocalized
          name="crossCurrencyPaymentAmount"
          value={crossCurrencyPaymentAmount}
          defaultValue={0}
          onChange={setCrossCurrencyPaymentAmount}
          suffix={subjectCurrencyId && <Text colorVariant="secondary">{subjectCurrencyId}</Text>}
          size="sm"
        />
      </Styled.PaymentInputWrapper>
    </Flex>
  )
}
